import styled from 'styled-components'

export const AlertContainer = styled.div<{ type: 'danger' | 'success' }>`
  display: flex;
  align-items: center;
  background: ${({ theme, type }) =>
    type === 'danger'
      ? theme.colors.errorSecondary
      : theme.colors.successSecondary};
  border-radius: 8px;
  padding: 0 6px;
`

export const AlertMessage = styled.p<{ type: 'danger' | 'success' }>`
  margin-left: 8px;
  font-size: 13px;
  line-height: 20px;
  text-transform: capitalize;
  color: ${({ theme, type }) =>
    type === 'danger' ? theme.colors.error : theme.colors.success};
`
